import { createRouter, createWebHistory } from 'vue-router'
import asyncRoutes, { scopeList } from '@/router/route-async.js'
import constantRoutes from '@/router/route-constant'
// 引入路由权限控制
import { setupRoutePermission as setupDashboardRoutePermission } from './permission'
// import { setupRoutePermission as setupWebRoutePermission } from './web/permission'

const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes
})

export const setupRouter = (app) => {
  app.use(router)

  // const webPathPrefix = ['/book', '/s/']
  // 判断当前的路由参数
  // 控制使用的是dashboard的permission还是web的permission
  // if (webPathPrefix.some((item) => location.pathname.startsWith(item))) {
  //   setupWebRoutePermission(router)
  // } else {
  setupDashboardRoutePermission(router, asyncRoutes)
  // }
}

export { scopeList, constantRoutes, asyncRoutes }

export default router
